import type { ReactNode } from "react";

export interface BadgeProps {
  variant?: "default" | "primary" | "success" | "warning" | "error" | "live";
  dot?: boolean;
  children: ReactNode;
  className?: string;
}

/**
 * Status badge with multiple semantic variants and optional dot indicator.
 */
export function Badge({
  variant = "default",
  dot = false,
  children,
  className = "",
}: BadgeProps) {
  const classes = [
    "badge",
    `badge--${variant}`,
    dot ? "badge--dot" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <span className={classes}>{children}</span>;
}
